var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9057 22.3822C44.9057 33.5684 36.6163 42.8162 25.8476 44.3169C24.8407 44.4566 23.8106 44.5295 22.7649 44.5295C21.5579 44.5295 20.3725 44.4333 19.2183 44.2471C8.6746 42.5493 0.622559 33.4055 0.622559 22.3822C0.622559 10.1501 10.5363 0.233398 22.7633 0.233398C34.9903 0.233398 44.9057 10.1501 44.9057 22.3822Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8476 18.0166V22.8415H31.8145L30.8697 29.3409H25.8476V44.3153C24.8407 44.4549 23.8106 44.5279 22.7649 44.5279C21.5579 44.5279 20.3726 44.4317 19.2183 44.2454V29.3409H13.7153V22.8415H19.2183V16.938C19.2183 13.2755 22.1862 10.3052 25.8492 10.3052V10.3083C25.86 10.3083 25.8693 10.3052 25.8802 10.3052H31.8161V15.9262H27.9374C26.7847 15.9262 25.8492 16.862 25.8492 18.0151L25.8476 18.0166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.03caf65a1fe04a9005f8c0e2836472ed.svg";
export { ForwardRef as ReactComponent };